import { Box, CircularProgress, Typography } from '@mui/material'

export function LoadingFallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress color='primary' size={40} thickness={4} />
      <Typography variant='body1' sx={{ mt: 2 }}>
        Loading...
      </Typography>
    </Box>
  )
}
